import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LayoutsComponent } from '../../layouts/layouts.component';

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.scss'],
    standalone: true,
    imports: [LayoutsComponent, RouterLink]
})
export class ServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
